import { useEffect, useState } from 'react';

// Countdown pill shown on the tutor's view of a child sitting a timed
// assessment. The child broadcasts an assessment-timer-sync when the timer
// starts and every 30s after; between syncs this ticks locally so only this
// pill re-renders each second, never the tile around it.
function TutorAssessmentTimer({ remainingSeconds, syncedAt }) {
    const [displaySeconds, setDisplaySeconds] = useState(null);

    useEffect(() => {
        if (remainingSeconds == null || syncedAt == null) {
            setDisplaySeconds(null);
            return undefined;
        }
        // Recompute from the sync point on every tick — immune to interval
        // drift and to time already elapsed before this component mounted.
        const compute = () =>
            Math.max(0, remainingSeconds - Math.round((Date.now() - syncedAt) / 1000));
        setDisplaySeconds(compute());
        const id = setInterval(() => setDisplaySeconds(compute()), 1000);
        return () => clearInterval(id);
    }, [remainingSeconds, syncedAt]);

    if (displaySeconds == null) return null;

    const minutes = Math.floor(displaySeconds / 60);
    const seconds = String(displaySeconds % 60).padStart(2, '0');
    const isLow = displaySeconds < 5 * 60;

    return (
        <div
            className={`absolute top-2 right-2 z-50 px-2 py-0.5 rounded-full border text-xs font-medium pointer-events-none ${
                isLow
                    ? 'bg-red-100 border-red-300 text-red-700'
                    : 'bg-amber-100 border-amber-300 text-amber-900'
            }`}
            title="Assessment time remaining"
        >
            ⏱ {minutes}:{seconds}
        </div>
    );
}

export default TutorAssessmentTimer;
